var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#26272B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8757 20.5834C13.3924 20.5834 13.0007 20.9752 13.0007 21.4584C13.0007 21.9417 13.3924 22.3334 13.8757 22.3334H17.3757C17.8589 22.3334 18.2507 21.9417 18.2507 21.4584C18.2507 20.9752 17.8589 20.5834 17.3757 20.5834H13.8757Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.709 10.6702C10.2927 10.6702 8.33398 12.6289 8.33398 15.0452V24.9539C8.33398 27.3702 10.2928 29.3289 12.709 29.3289H27.2832C29.6992 29.3289 31.6579 27.3699 31.6582 24.9539L31.6628 15.0452C31.6628 12.6289 29.7039 10.6702 27.2878 10.6702H12.709ZM10.084 15.0452C10.084 13.5954 11.2592 12.4202 12.709 12.4202H27.2878C28.7375 12.4202 29.9128 13.5954 29.9128 15.0452V16.5001H10.084V15.0452ZM12.709 27.5789C11.2592 27.5789 10.084 26.4037 10.084 24.9539V18.2501H29.9122L29.9082 24.9539C29.9082 26.4036 28.7329 27.5789 27.2832 27.5789H12.709Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.867607620092443eeced86a4190ed2b9.svg";
export { ForwardRef as ReactComponent };